// Analytics retired 2026-02. We use Cloudflare Web Analytics instead.
// These exports are kept as no-ops so existing call sites compile cleanly.

export function useTrackPageView(/* path, opts */) {
  // intentional no-op
}

export function logSearchEvent(/* type, label */) {
  // intentional no-op
}
